import { QueryClient } from '@tanstack/react-query';
export var queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false, // Set refetchOnWindowFocus globally
            retry: 1, // retry once if failed
            retryDelay: 2000, // retry after 2 seconds
            staleTime: 5 * 60 * 1000 // 5 minutes - data stays fresh for 5 minutes
        }
    }
});
